(function ($) {
  'use strict';
  $(function () {
    $(document).on('click', '.switch__lab', function () {
      $(this).closest('.switch').find('label').trigger('click');
    });
  });
})(jQuery);
